import type { SVGProps } from "react";
import { memo } from "react";
const HealthLake = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#055F4E" />
        <stop offset="100%" stopColor="#56C0A7" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M59 48h2v-6h-2zm7 9h-4a1 1 0 0 1-1-1v-4h-4v4a1 1 0 0 1-1 1h-4v4h4a1 1 0 0 1 1 1v4h4v-4a1 1 0 0 1 1-1h4zm2-1v6a1 1 0 0 1-1 1h-4v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-4h-4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h4v-4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4h4a1 1 0 0 1 1 1M33 19h14v-5H33zm-2 1v-7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H32a1 1 0 0 1-1-1m-10-2.455c0-.852.693-1.545 1.546-1.545H29v-2h-6.454A3.55 3.55 0 0 0 19 17.545V33h2zm38 0V33h2V17.545A3.55 3.55 0 0 0 57.454 14H51v2h6.454c.853 0 1.546.693 1.546 1.545m-38 46.91V42h-2v22.455A3.55 3.55 0 0 0 22.546 68H52v-2H22.546A1.547 1.547 0 0 1 21 64.455M51.618 37l-4.723-9.447c-.172-.344-.495-.542-.911-.553a1 1 0 0 0-.892.581l-5.251 11.377-5.009-7.513c-.371-.556-1.293-.556-1.664 0L29.465 37H12v2h18c.334 0 .646-.167.832-.445L34 33.803l5.168 7.752a1 1 0 0 0 1.74-.136l5.128-11.111 4.069 8.139c.17.339.516.553.895.553h17v-2zM25 54h18v-2H25zm0 6h18v-2H25z"
      />
    </g>
  </svg>
);
const Memo = memo(HealthLake);
export default Memo;
